import { render, staticRenderFns } from "./Fooien.vue?vue&type=template&id=e25027de&scoped=true"
import script from "./Fooien.vue?vue&type=script&lang=js"
export * from "./Fooien.vue?vue&type=script&lang=js"
import style0 from "./Fooien.vue?vue&type=style&index=0&id=e25027de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25027de",
  null
  
)

export default component.exports